
























































































































































































































































import SquareBlock from '@/components/map/SquareBlock.vue'
import Room from '@/components/map/Room.vue'

export default {
  components: { SquareBlock, Room },
  props: {
    patients: {
      type: Array,
      required: true,
    },
    patientsByRoomNumber: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
}
